import RegFormsTitle from './RegFormsTitle';
export default RegFormsTitle;
